<div class="flex-fill d-flex flex-row card">
    <div class="d-flex flex-column flex-fill col-sm-8 p-1">
        <!-- <h4 *ngIf="!showAsComponent">Open Invoices</h4> -->
        <div class="d-flex">
            <div class="column ms-2 me-3"><span class="color-legend with-border pending-ach"></span> - Pending ACH</div>
            <div class="column ms-2 me-3"><span class="color-legend with-border completed-ach"></span> - Deposited ACH</div>
        </div>
        <div class="d-flex flex-column flex-fill p-1">
            <dx-data-grid
                #openInvoicesDataGrid
                keyExpr="id"
                class="flex-fill d-flex flex-column"
                height="100px"
                [dataSource]="invoices"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onRowDblClick)="onRowDoubleClick($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onExporting)="onExporting($event)"
                [columnAutoWidth]="false"
                [wordWrapEnabled]="true"
            >
                <dxi-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-column>
                <dxi-column dataField="invoiceNumber" caption="Invoice #" width="75" cellTemplate="invoiceLinkTemplate"></dxi-column>
                <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="invoiceBalance" caption="Balance" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="dealer" caption="Dealer" width="175" cellTemplate="dealerLinkTemplate"></dxi-column>
                <dxi-column dataField="packingSlipList" caption="Pack Slip #" width="90" cellTemplate="packSlipTemplate"></dxi-column>
                <dxi-column dataField="emailed" caption="Emailed" dataType="date" width="100"></dxi-column>
                <dxi-column dataField="invoiceDate" caption="Invoice Date" dataType="date" width="100"></dxi-column>
                <dxi-column dataField="dueDate" caption="Due Date" dataType="date" width="100"></dxi-column>
                <dxi-column dataField="paymentMethods" caption="Payment Method" width="120"></dxi-column>
                <dxi-column dataField="notesListHtml" caption="Notes" [encodeHtml]="false"></dxi-column>
                <dxi-column width="100"></dxi-column>

                <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                    <a *ngIf="cell && isPaymentAdmin" [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
                    <div *ngIf="cell && !isPaymentAdmin" [innerHtml]="cell.text"></div>
                </div>

                <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                    <a *ngIf="cell && isPaymentAdmin" [routerLink]="'/dealers/overview/' + cell.data.dealerId" [innerHtml]="cell.text"></a>
                    <div *ngIf="cell && !isPaymentAdmin" [innerHtml]="cell.text"></div>
                </div>

                <div *dxTemplate="let cell of 'packSlipTemplate'">
                    <a *ngFor="let packSlipNumber of cell.data.packingSlipList" [routerLink]="[]" (click)="printPackingSlip(packSlipNumber)">{{ packSlipNumber || '' }} </a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        class="btn btn-success me-3 mb-2"
                        (click)="receivePayment()"
                        [disabled]="openInvoicesDataGrid.instance.getSelectedRowsData().length === 0"
                        [hidden]="!isPaymentAdmin"
                    >
                        Receive Payment
                    </button>
                    <button
                        class="btn btn-primary me-3 mb-2"
                        (click)="requestAchPayment()"
                        [disabled]="openInvoicesDataGrid.instance.getSelectedRowsData().length === 0"
                        [hidden]="!isPaymentAdmin"
                    >
                        Request Payment via ACH
                    </button>
                    <button class="btn btn-success me-3 mb-2" (click)="addNote()" [disabled]="openInvoicesDataGrid.instance.getSelectedRowsData().length !== 1">Add Note</button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="invoices" class="me-3">
                        <strong
                            >{{ openInvoicesDataGrid.instance.totalCount() + ' items' }}
                            {{ openInvoicesDataGrid.instance.getSelectedRowsData().length > 0 ? openInvoicesDataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>

                <dxo-summary>
                    <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                    <dxi-total-item column="invoiceBalance" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                </dxo-summary>

                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-search-panel [visible]="true"></dxo-search-panel>
                <dxo-selection [mode]="'single'"></dxo-selection>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payment-invoice-overview-grid"></dxo-state-storing>
            </dx-data-grid>
        </div>
    </div>
    <!-- <div *ngIf="!showAsComponent" class="d-flex flex-fill flex-column col-sm-4">
        <div class="d-flex flex-column flex-fill p-1">
            <h4>Recent Payments</h4>
            <dx-data-grid
                #dataGrid
                [keyExpr]="'id'"
                class="flex-fill d-flex flex-column"
                height="100px"
                [dataSource]="payments"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onRowDblClick)="onPaymentDoubleClick($event)"
                [columnAutoWidth]="true"
            >
                <dxi-column dataField="id" width="75"></dxi-column>
                <dxi-column dataField="dealer.companyName" caption="Dealer" width="150" cellTemplate="dealerLinkTemplate"></dxi-column>
                <dxi-column dataField="paymentDate" caption="Date" width="75"></dxi-column>
                <dxi-column dataField="paymentMethod.name" caption="Method" width="75"></dxi-column>
                <dxi-column dataField="paymentAmount" caption="Amount" [format]="{ type: 'currency', precision: 2 }" width="75"></dxi-column>
                <dxi-column dataField="referenceNumber" caption="Ref#" width="75"></dxi-column>
                <dxi-column dataField="quickBooksId" caption="QB ID" width="75"></dxi-column>
                <dxi-column dataField="quickBooksLastExport" caption="QB Export" width="75"></dxi-column>
                <dxi-column dataField="invoiceListString" caption="Invoices"></dxi-column>

                <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                    <a *ngIf="cell && isPaymentAdmin" [routerLink]="'/dealers/overview/' + cell.data.dealerId" [innerHtml]="cell.text"></a>
                    <div *ngIf="cell && !isPaymentAdmin" [innerHtml]="cell.text"></div>
                </div>
                <div *dxTemplate="let cell of 'invoiceLinksTemplate'" class="links-template">
                    <ng-container *ngFor="let invoice of cell.data.invoices">
                        <a [routerLink]="'/invoices/' + invoice.id">{{ invoice.invoiceNumber }}</a>
                    </ng-container>
                </div>

                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-search-panel [visible]="true"></dxo-search-panel>
                <dxo-selection mode="multiple"></dxo-selection>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payments-grid"></dxo-state-storing>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        class="btn btn-primary me-1 mb-2"
                        (click)="openPayment(dataGrid.instance.getSelectedRowsData()[0]?.id)"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                        [hidden]="!isPaymentAdmin"
                    >
                        Open
                    </button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="payments" class="me-3">
                        <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                    </span>
                </div>
            </dx-data-grid>
        </div>
    </div> -->
</div>
